import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  analyticsApiRef,
  AnyApiFactory,
  configApiRef,
  createApiFactory,
} from '@backstage/core-plugin-api';
import { activityAnalyticsApiRef } from '@internal/plugin-activity';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),

  // Backstage's plugins already report navigation, searches and result clicks
  // through the analytics API; the default implementation throws them away.
  // Pointing it at the activity plugin is what records "viewed this
  // component" without adding a call site to any plugin.
  createApiFactory({
    api: analyticsApiRef,
    deps: { impl: activityAnalyticsApiRef },
    factory: ({ impl }) => impl,
  }),
];
